import { render, staticRenderFns } from "./OilinessTemplate.vue?vue&type=template&id=713114db"
import script from "./OilinessTemplate.vue?vue&type=script&lang=js"
export * from "./OilinessTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports